import React, { useState, useMemo, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Check, AlertTriangle, Shirt, Type, Palette, ChevronDown, ChevronUp, Info, Printer, Calendar, Hash, Scissors } from 'lucide-react';

// ==================== DATOS CON IMÁGENES INDIVIDUALES ====================

const ESTILOS_CAMISA = [
  { id: 'clasica_formal', nombre: 'Clásica Formal', mangaCorta: false, imagen: '/assets/configurator/camisa/derived/estilos/clasica-formal.png' },
  { id: 'clasica_informal', nombre: 'Clásica Informal', mangaCorta: false, imagen: '/assets/configurator/camisa/derived/estilos/clasica-informal.png' },
  { id: 'clasica_manga_corta', nombre: 'Clásica Manga corta', mangaCorta: true, imagen: '/assets/configurator/camisa/derived/estilos/clasica-manga-corta.png' },
  { id: 'camisa_cubana', nombre: 'Camisa Cubana', mangaCorta: true, imagen: '/assets/configurator/camisa/derived/estilos/camisa-cubana.png' },
  { id: 'camisa_smoking', nombre: 'Camisa Smoking', mangaCorta: false, imagen: '/assets/configurator/camisa/derived/estilos/camisa-smoking.png' },
  { id: 'camisa_guayabera', nombre: 'Camisa Guayabera', mangaCorta: false, imagen: '/assets/configurator/camisa/derived/estilos/camisa-guayabera.png' },
  { id: 'camisa_vaquera', nombre: 'Camisa Vaquera', mangaCorta: false, imagen: '/assets/configurator/camisa/derived/estilos/camisa-vaquera.png' },
  { id: 'camisa_militar', nombre: 'Camisa Militar', mangaCorta: false, imagen: '/assets/configurator/camisa/derived/estilos/camisa-militar.png' }
];

const TIPOS_CIERRE = [
  { id: 'sencilla', nombre: 'Sencilla', imagen: '/assets/configurator/camisa/derived/cierres/sencilla.png' },
  { id: 'con_pespunte', nombre: 'Con pespunte', imagen: '/assets/configurator/camisa/derived/cierres/con-pespunte.png' },
  { id: 'oculta', nombre: 'Oculta', imagen: '/assets/configurator/camisa/derived/cierres/oculta.png' }
];

const TIPOS_CUELLO = [
  { id: '1', nombre: 'Cuello italiano abierto con punta larga', imagen: '/assets/configurator/camisa/derived/cuellos/cuello-1.png' },
  { id: '2', nombre: 'Cuello clásico formal de punta larga', imagen: '/assets/configurator/camisa/derived/cuellos/cuello-2.png' },
  { id: '3', nombre: 'Cuello semiabierto de punta corta', imagen: '/assets/configurator/camisa/derived/cuellos/cuello-3.png' },
  { id: '4', nombre: 'Cuello clásico recto de punta media', imagen: '/assets/configurator/camisa/derived/cuellos/cuello-4.png' },
  { id: '5', nombre: 'Cuello mao cerrado', imagen: '/assets/configurator/camisa/derived/cuellos/cuello-5.png' },
  { id: '6', nombre: 'Cuello abotonado / button down', imagen: '/assets/configurator/camisa/derived/cuellos/cuello-6.png' },
  { id: '7', nombre: 'Cuello redondeado', imagen: '/assets/configurator/camisa/derived/cuellos/cuello-7.png' },
  { id: '8', nombre: 'Cuello mao abierto con punta interna', imagen: '/assets/configurator/camisa/derived/cuellos/cuello-8.png' }
];

const TIPOS_PUNO = [
  { id: '6', nombre: 'Puño sencillo recto con doble botón', imagen: '/assets/configurator/camisa/derived/punos/puno-6.png' },
  { id: '7', nombre: 'Puño sencillo redondeado con doble botón', imagen: '/assets/configurator/camisa/derived/punos/puno-7.png' },
  { id: '8', nombre: 'Puño sencillo cuadrado con doble botón', imagen: '/assets/configurator/camisa/derived/punos/puno-8.png' },
  { id: '9', nombre: 'Puño francés / doble para mancornas', imagen: '/assets/configurator/camisa/derived/punos/puno-9.png' },
  { id: '10', nombre: 'Puño alto recto con dos botones', imagen: '/assets/configurator/camisa/derived/punos/puno-10.png' }
];

const TIPOS_PINZAS = [
  { id: 'a_los_costados', nombre: 'Pinzas laterales de espalda', imagen: '/assets/configurator/camisa/derived/pinzas/a-los-costados.png' },
  { id: 'central', nombre: 'Pinza central doble de espalda', imagen: '/assets/configurator/camisa/derived/pinzas/central.png' }
];

const COLORES_BORDADO = [
  { id: '1', nombre: 'Negro', hex: '#000000', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-negro.png' },
  { id: '2', nombre: 'Blanco', hex: '#FFFFFF', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-blanco.png' },
  { id: '3', nombre: 'Azul oscuro', hex: '#1a237e', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-azul-oscuro.png' },
  { id: '4', nombre: 'Azul claro', hex: '#64b5f6', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-azul-claro.png' },
  { id: '5', nombre: 'Azul medio', hex: '#1e88e5', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-azul-medio.png' },
  { id: '6', nombre: 'Morado', hex: '#8e24aa', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-morado.png' },
  { id: '7', nombre: 'Verde', hex: '#2e7d32', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-verde.png' },
  { id: '8', nombre: 'Rojo', hex: '#d32f2f', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-rojo.png' },
  { id: '9', nombre: 'Rosado', hex: '#ec407a', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-rosado.png' },
  { id: '10', nombre: 'Dorado / Mostaza', hex: '#ffb300', imagenPerro: '/assets/configurator/camisa/derived/bordados/perro/perro-dorado-mostaza.png' }
];

const CALIGRAFIAS = [
  { id: 'bodoni', nombre: 'Bodoni', fontFamily: "'Bodoni Moda', serif" },
  { id: 'cursiva', nombre: 'Cursiva', fontFamily: "'Dancing Script', cursive" },
  { id: 'new', nombre: 'New', fontFamily: "'Cinzel', serif" }
];

const PARTES_BORDADO = [
  { id: 'puno_izquierdo', nombre: 'Puño Izquierdo' },
  { id: 'puno_derecho', nombre: 'Puño Derecho' },
  { id: 'pecho_izquierdo', nombre: 'Pecho Izquierdo' },
  { id: 'pecho_derecho', nombre: 'Pecho Derecho' },
  { id: 'espalda', nombre: 'Espalda' }
];

const TIPOS_BOLSILLO = [
  { id: 'sin_bolsillo', nombre: 'Sin bolsillo' },
  { id: 'un_bolsillo', nombre: '1 Bolsillo' },
  { id: 'dos_bolsillos', nombre: '2 Bolsillos' },
  { id: 'bolsillo_con_tapa', nombre: 'Bolsillo con tapa' }
];

const TIPOS_MANGA = [
  { id: 'larga', nombre: 'Manga larga' },
  { id: 'corta', nombre: 'Manga corta' },
  { id: '3_4', nombre: 'Manga 3/4' }
];

const TIPOS_DOBLADILLO = [
  { id: 'recto', nombre: 'Recto' },
  { id: 'curvo', nombre: 'Curvo' },
  { id: 'con_abertura', nombre: 'Con abertura lateral' }
];

// ==================== COMPONENTES AUXILIARES ====================

const TarjetaOpcion = React.memo(({ opcion, seleccionado, onClick, mostrarManga = false, compact = false, mostrarCodigo = false }) => {
  const [imgError, setImgError] = useState(false);
  
  // Generar el texto completo de la tarjeta
  const textoCompleto = opcion.nombre;
  
  return (
    <button
      type="button"
      onClick={onClick}
      title={textoCompleto}
      className={`relative p-2 rounded-lg border-2 transition-all duration-200 flex flex-col ${
        seleccionado
          ? 'border-emerald-500 bg-emerald-500/20 shadow-lg shadow-emerald-500/20'
          : 'border-zinc-700 bg-zinc-800/50 hover:border-zinc-500 hover:bg-zinc-800'
      } ${compact ? 'p-1' : ''}`}
    >
      <div className={`aspect-square w-full bg-white rounded-md overflow-hidden mb-2 flex items-center justify-center flex-shrink-0 ${compact ? 'mb-1' : ''}`}>
        {opcion.imagen && !imgError ? (
          <img 
            src={opcion.imagen}
            alt={opcion.nombre}
            className="w-full h-full object-contain"
            onError={() => setImgError(true)}
            loading="lazy"
          />
        ) : opcion.hex ? (
          <div 
            className="w-full h-full border border-zinc-300"
            style={{ backgroundColor: opcion.hex }}
          />
        ) : (
          <div className="w-full h-full bg-zinc-200 flex items-center justify-center">
            <Shirt className="w-6 h-6 text-zinc-400" />
          </div>
        )}
      </div>
      
      {/* Nombre completo sin truncar - permite hasta 3 líneas */}
      <div className={`text-[11px] font-medium text-white text-center leading-tight flex-grow flex items-center justify-center ${compact ? 'text-[10px]' : ''}`} style={{ minHeight: '2.5rem' }}>
        <span className="break-words hyphens-auto" style={{ 
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          wordBreak: 'break-word'
        }}>
          {textoCompleto}
        </span>
      </div>
      
      {mostrarManga && opcion.mangaCorta !== undefined && (
        <div className={`text-[10px] text-center mt-0.5 ${opcion.mangaCorta ? 'text-amber-400' : 'text-zinc-500'}`}>
          {opcion.mangaCorta ? 'Manga corta' : 'Manga larga'}
        </div>
      )}
      
      {seleccionado && (
        <div className="absolute -top-1 -right-1 w-5 h-5 bg-emerald-500 rounded-full flex items-center justify-center shadow-lg">
          <Check className="w-3 h-3 text-white" />
        </div>
      )}
    </button>
  );
});

TarjetaOpcion.displayName = 'TarjetaOpcion';

const SeccionSelector = React.memo(({ titulo, opciones, valorSeleccionado, onSelect, columnas = 4, mostrarManga = false, compact = false }) => {
  const [expandido, setExpandido] = useState(true);
  
  const opcionSeleccionada = useMemo(() => 
    opciones.find(o => o.id === valorSeleccionado),
    [opciones, valorSeleccionado]
  );
  
  return (
    <div className="mb-3">
      <button
        type="button"
        onClick={() => setExpandido(!expandido)}
        className="w-full flex items-center justify-between p-2.5 bg-zinc-800/60 rounded-lg hover:bg-zinc-800/80 transition-colors"
      >
        <span className="font-medium text-white text-sm">{titulo}</span>
        <div className="flex items-center gap-2">
          {opcionSeleccionada && (
            <span className="text-xs text-emerald-400 flex items-center gap-1">
              <Check className="w-3 h-3" />
              {opcionSeleccionada.nombre}
            </span>
          )}
          {expandido ? <ChevronUp className="w-4 h-4 text-zinc-400" /> : <ChevronDown className="w-4 h-4 text-zinc-400" />}
        </div>
      </button>
      
      {expandido && (
        <div className={`mt-2 grid gap-2 p-2 bg-zinc-900/50 rounded-lg grid-cols-2 sm:grid-cols-3 md:grid-cols-${columnas}`}>
          {opciones.map((opcion) => (
            <TarjetaOpcion
              key={opcion.id}
              opcion={opcion}
              seleccionado={valorSeleccionado === opcion.id}
              onClick={() => onSelect(opcion.id)}
              mostrarManga={mostrarManga}
              compact={compact}
            />
          ))}
        </div>
      )}
    </div>
  );
});

SeccionSelector.displayName = 'SeccionSelector';

const SelectorColores = React.memo(({ titulo, colores, valorSeleccionado, onSelect, deshabilitado = false }) => {
  const [expandido, setExpandido] = useState(true);
  
  const colorSeleccionado = useMemo(() => 
    colores.find(c => c.id === valorSeleccionado),
    [colores, valorSeleccionado]
  );
  
  if (deshabilitado) {
    return (
      <div className="mb-3 p-2.5 bg-zinc-800/30 rounded-lg opacity-50">
        <span className="font-medium text-zinc-500 text-sm">{titulo}</span>
        <span className="ml-2 text-xs text-zinc-600">No aplica</span>
      </div>
    );
  }
  
  return (
    <div className="mb-3">
      <button
        type="button"
        onClick={() => setExpandido(!expandido)}
        className="w-full flex items-center justify-between p-2.5 bg-zinc-800/60 rounded-lg hover:bg-zinc-800/80 transition-colors"
      >
        <span className="font-medium text-white text-sm">{titulo}</span>
        <div className="flex items-center gap-2">
          {colorSeleccionado && (
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 rounded-full border-2 border-white/50" style={{ backgroundColor: colorSeleccionado.hex }} />
              <span className="text-xs text-emerald-400">{colorSeleccionado.nombre}</span>
            </div>
          )}
          {expandido ? <ChevronUp className="w-4 h-4 text-zinc-400" /> : <ChevronDown className="w-4 h-4 text-zinc-400" />}
        </div>
      </button>
      
      {expandido && (
        <div className="mt-2 grid grid-cols-5 gap-2 p-2 bg-zinc-900/50 rounded-lg">
          {colores.map((color) => (
            <button
              key={color.id}
              type="button"
              onClick={() => onSelect(color.id)}
              title={color.nombre}
              className={`relative p-1 rounded-lg transition-all ${
                valorSeleccionado === color.id
                  ? 'ring-2 ring-emerald-500 ring-offset-2 ring-offset-zinc-900'
                  : 'hover:ring-1 hover:ring-zinc-500'
              }`}
            >
              <div className="w-full aspect-square rounded-md border-2 border-zinc-600" style={{ backgroundColor: color.hex }} />
              <div className="text-[10px] text-center mt-1 text-zinc-400 truncate">{color.nombre}</div>
              {valorSeleccionado === color.id && (
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full flex items-center justify-center">
                  <Check className="w-2.5 h-2.5 text-white" />
                </div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
});

SelectorColores.displayName = 'SelectorColores';

// ==================== COMPONENTE VISTA PREVIA DEL BOCETO TÉCNICO ====================
// Muestra: Camisa base a la izquierda + Lista de opciones seleccionadas a la derecha

const VistaPreviaCamisa = React.memo(({ config }) => {
  const estiloInfo = useMemo(() => ESTILOS_CAMISA.find(e => e.id === config.configuracion?.estilo), [config.configuracion?.estilo]);
  const cierreInfo = useMemo(() => TIPOS_CIERRE.find(c => c.id === config.configuracion?.cierre), [config.configuracion?.cierre]);
  const cuelloInfo = useMemo(() => TIPOS_CUELLO.find(c => c.id === config.configuracion?.cuello), [config.configuracion?.cuello]);
  const punoInfo = useMemo(() => TIPOS_PUNO.find(p => p.id === config.configuracion?.punos), [config.configuracion?.punos]);
  const pinzasInfo = useMemo(() => TIPOS_PINZAS.find(p => p.id === config.configuracion?.pinzas), [config.configuracion?.pinzas]);
  const colorBordado = useMemo(() => COLORES_BORDADO.find(c => c.id === config.bordado?.colorBordado), [config.bordado?.colorBordado]);
  const caligrafiaInfo = useMemo(() => CALIGRAFIAS.find(c => c.id === config.bordado?.caligrafia), [config.bordado?.caligrafia]);
  
  const esMangaCorta = estiloInfo?.mangaCorta;
  const tieneEstilo = !!estiloInfo;
  
  // Iconos SVG para cada opción
  const IconCierre = () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 4v16M16 4v16" />
      <path d="M8 8h8M8 12h8M8 16h8" />
    </svg>
  );
  
  const IconCuello = () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M4 8c0 0 4-4 8-4s8 4 8 4" />
      <path d="M6 8l-2 12h16l-2-12" />
      <path d="M10 8v4M14 8v4" />
    </svg>
  );
  
  const IconPuno = () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="4" y="6" width="16" height="12" rx="2" />
      <path d="M8 6v12M16 6v12" />
    </svg>
  );
  
  const IconPinzas = () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M8 4c0 4 0 16 0 16" />
      <path d="M16 4c0 4 0 16 0 16" />
      <path d="M8 10c2 2 6 2 8 0" />
    </svg>
  );
  
  // Estado inicial: sin estilo seleccionado
  if (!tieneEstilo) {
    return (
      <div className="bg-white rounded-xl border border-zinc-200 overflow-hidden">
        <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
          <div className="flex items-center gap-2 text-amber-700">
            <Info className="w-5 h-5" />
            <span className="text-sm font-semibold">Vista Previa - Opciones seleccionadas</span>
          </div>
        </div>
        
        <div className="p-6 flex items-center justify-center" style={{ minHeight: '300px' }}>
          <div className="text-center text-zinc-400">
            <Shirt className="w-20 h-20 mx-auto mb-4 opacity-20" />
            <p className="text-sm font-medium">Selecciona un estilo para iniciar</p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-xl border border-zinc-200 overflow-hidden">
      {/* Header con icono de información */}
      <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
        <div className="flex items-center gap-2 text-amber-700">
          <Info className="w-5 h-5" />
          <span className="text-sm font-semibold">Vista Previa - Opciones seleccionadas</span>
        </div>
      </div>
      
      {/* Contenido principal: Camisa + Lista de opciones */}
      <div className="flex flex-col md:grid md:grid-cols-2 gap-0">
        
        {/* === COLUMNA IZQUIERDA: CAMISA BASE LIMPIA (Oculta en móvil, visible en md+) === */}
        <div className="hidden md:flex relative bg-zinc-50 items-center justify-center p-4 border-r border-zinc-200" style={{ minHeight: '380px' }}>
          <img 
            src={estiloInfo.imagen}
            alt={`${estiloInfo.nombre}`}
            className="max-w-full max-h-72 object-contain"
            style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.08))' }}
          />
        </div>
        
        {/* === COLUMNA DERECHA: LISTA DE OPCIONES === */}
        <div className="bg-white p-4 w-full">
          <div className="space-y-3">
            
            {/* Estilo */}
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center text-zinc-500 flex-shrink-0">
                <Shirt className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs text-zinc-400 uppercase tracking-wide">Estilo</div>
                <div className="text-sm font-semibold text-zinc-800">{estiloInfo.nombre}</div>
              </div>
            </div>
            
            {/* Cierre */}
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center text-zinc-500 flex-shrink-0">
                <IconCierre />
              </div>
              <div>
                <div className="text-xs text-zinc-400 uppercase tracking-wide">Cierre</div>
                <div className={`text-sm font-semibold ${cierreInfo ? 'text-zinc-800' : 'text-amber-500'}`}>
                  {cierreInfo?.nombre || 'Pendiente'}
                </div>
              </div>
            </div>
            
            {/* Cuello */}
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center text-zinc-500 flex-shrink-0">
                <IconCuello />
              </div>
              <div>
                <div className="text-xs text-zinc-400 uppercase tracking-wide">Cuello</div>
                <div className={`text-sm font-semibold ${cuelloInfo ? 'text-zinc-800' : 'text-amber-500'}`}>
                  {cuelloInfo ? cuelloInfo.id : 'Pendiente'}
                </div>
              </div>
            </div>
            
            {/* Puño */}
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center text-zinc-500 flex-shrink-0">
                <IconPuno />
              </div>
              <div>
                <div className="text-xs text-zinc-400 uppercase tracking-wide">Puño</div>
                <div className={`text-sm font-semibold ${esMangaCorta ? 'text-zinc-400' : (punoInfo ? 'text-zinc-800' : 'text-amber-500')}`}>
                  {esMangaCorta ? 'No aplica' : (punoInfo ? punoInfo.id : 'Pendiente')}
                </div>
              </div>
            </div>
            
            {/* Pinzas */}
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center text-zinc-500 flex-shrink-0">
                <IconPinzas />
              </div>
              <div>
                <div className="text-xs text-zinc-400 uppercase tracking-wide">Pinzas</div>
                <div className={`text-sm font-semibold ${pinzasInfo ? 'text-zinc-800' : 'text-amber-500'}`}>
                  {pinzasInfo?.nombre || 'Pendiente'}
                </div>
              </div>
            </div>
            
            {/* Perro bordado - Con imagen real si está activo y hay color */}
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center flex-shrink-0 overflow-hidden">
                {config.configuracion?.perroBordado && colorBordado?.imagenPerro ? (
                  <img 
                    src={colorBordado.imagenPerro}
                    alt="Perro bordado"
                    className="w-7 h-7 object-contain"
                  />
                ) : (
                  <span className="text-zinc-400 text-xs">-</span>
                )}
              </div>
              <div>
                <div className="text-xs text-zinc-400 uppercase tracking-wide">Perro bordado</div>
                <div className="text-sm font-semibold text-zinc-800">
                  {config.configuracion?.perroBordado ? 'Sí' : 'No'}
                </div>
              </div>
            </div>
            
            {/* Color del bordado - Solo si hay perro o iniciales */}
            {(config.configuracion?.perroBordado || config.bordado?.textoBordado) && (
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center flex-shrink-0 overflow-hidden">
                  {config.configuracion?.perroBordado && colorBordado?.imagenPerro ? (
                    <img 
                      src={colorBordado.imagenPerro}
                      alt={`Perro ${colorBordado?.nombre}`}
                      className="w-7 h-7 object-contain"
                    />
                  ) : (
                    <div 
                      className="w-5 h-5 rounded-full border-2 border-zinc-300"
                      style={{ backgroundColor: colorBordado?.hex || '#ccc' }}
                    />
                  )}
                </div>
                <div>
                  <div className="text-xs text-zinc-400 uppercase tracking-wide">Color del bordado</div>
                  <div className={`text-sm font-semibold flex items-center gap-2 ${colorBordado ? 'text-zinc-800' : 'text-amber-500'}`}>
                    {colorBordado && (
                      <div 
                        className="w-3 h-3 rounded-full"
                        style={{ backgroundColor: colorBordado.hex }}
                      />
                    )}
                    {colorBordado?.nombre || 'Pendiente'}
                  </div>
                </div>
              </div>
            )}
            
            {/* Iniciales bordadas - solo si hay texto */}
            {config.bordado?.textoBordado && (
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-zinc-600">ABC</span>
                </div>
                <div>
                  <div className="text-xs text-zinc-400 uppercase tracking-wide">Iniciales bordadas</div>
                  <div className="text-sm font-semibold text-zinc-800">{config.bordado.textoBordado}</div>
                </div>
              </div>
            )}
            
            {/* Caligrafía - solo si hay texto */}
            {config.bordado?.textoBordado && (
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded bg-zinc-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-serif italic text-zinc-600">ABC</span>
                </div>
                <div>
                  <div className="text-xs text-zinc-400 uppercase tracking-wide">Caligrafía</div>
                  <div className={`text-sm font-semibold ${caligrafiaInfo ? 'text-zinc-800' : 'text-amber-500'}`}>
                    {caligrafiaInfo?.nombre || 'Pendiente'}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

VistaPreviaCamisa.displayName = 'VistaPreviaCamisa';

// ==================== COMPONENTE RESUMEN DE CAMISA ====================

const ResumenCamisa = React.memo(({ config }) => {
  const estiloInfo = useMemo(() => ESTILOS_CAMISA.find(e => e.id === config.configuracion?.estilo), [config.configuracion?.estilo]);
  const cierreInfo = useMemo(() => TIPOS_CIERRE.find(c => c.id === config.configuracion?.cierre), [config.configuracion?.cierre]);
  const cuelloInfo = useMemo(() => TIPOS_CUELLO.find(c => c.id === config.configuracion?.cuello), [config.configuracion?.cuello]);
  const punoInfo = useMemo(() => TIPOS_PUNO.find(p => p.id === config.configuracion?.punos), [config.configuracion?.punos]);
  const pinzasInfo = useMemo(() => TIPOS_PINZAS.find(p => p.id === config.configuracion?.pinzas), [config.configuracion?.pinzas]);
  const colorInfo = useMemo(() => COLORES_BORDADO.find(c => c.id === config.bordado?.colorBordado), [config.bordado?.colorBordado]);
  const caligrafiaInfo = useMemo(() => CALIGRAFIAS.find(c => c.id === config.bordado?.caligrafia), [config.bordado?.caligrafia]);
  
  const esMangaCorta = estiloInfo?.mangaCorta;
  
  const FilaResumen = ({ label, valor, pendiente = false }) => (
    <div className="flex justify-between py-1">
      <span className="text-zinc-400">{label}:</span>
      <span className={pendiente ? 'text-amber-400 text-sm' : 'text-white font-medium'}>
        {valor}
      </span>
    </div>
  );
  
  return (
    <div className="bg-zinc-800/50 rounded-xl p-4">
      <h3 className="text-sm font-semibold text-white mb-3 flex items-center gap-2">
        <Check className="w-4 h-4 text-emerald-500" />
        Resumen de Camisa
      </h3>
      
      <div className="space-y-1 text-sm">
        <FilaResumen 
          label="Estilo" 
          valor={estiloInfo?.nombre || 'Pendiente por seleccionar'}
          pendiente={!estiloInfo}
        />
        <FilaResumen 
          label="Cierre" 
          valor={cierreInfo?.nombre || 'Pendiente por seleccionar'}
          pendiente={!cierreInfo}
        />
        <FilaResumen 
          label="Cuello" 
          valor={cuelloInfo ? `Cuello ${cuelloInfo.id}` : 'Pendiente por seleccionar'}
          pendiente={!cuelloInfo}
        />
        <FilaResumen 
          label="Puños" 
          valor={esMangaCorta ? 'No aplica' : (punoInfo ? `Puño ${punoInfo.id}` : 'Pendiente por seleccionar')}
          pendiente={!esMangaCorta && !punoInfo}
        />
        <FilaResumen 
          label="Pinzas" 
          valor={pinzasInfo?.nombre || 'Pendiente por seleccionar'}
          pendiente={!pinzasInfo}
        />
        <FilaResumen 
          label="Perro bordado" 
          valor={config.configuracion?.perroBordado ? 'Sí' : 'No'}
        />
        
        {(config.configuracion?.perroBordado || config.bordado?.textoBordado) && (
          <div className="flex justify-between py-1">
            <span className="text-zinc-400">Color bordado:</span>
            <span className={!colorInfo ? 'text-amber-400 text-sm' : 'text-white font-medium flex items-center gap-2'}>
              {colorInfo ? (
                <>
                  <div 
                    className="w-4 h-4 rounded-full border border-zinc-500"
                    style={{ backgroundColor: colorInfo.hex }}
                  />
                  {colorInfo.nombre}
                </>
              ) : 'Pendiente por seleccionar'}
            </span>
          </div>
        )}
        
        {config.bordado?.textoBordado && (
          <>
            <FilaResumen label="Letras bordadas" valor={config.bordado.textoBordado} />
            <FilaResumen 
              label="Caligrafía" 
              valor={caligrafiaInfo?.nombre || 'Pendiente por seleccionar'}
              pendiente={!caligrafiaInfo}
            />
          </>
        )}
      </div>
    </div>
  );
});

ResumenCamisa.displayName = 'ResumenCamisa';

// ==================== INPUT DE MEDIDA PARA TALLER ====================

const MedidaInput = ({ label, value, onChange, placeholder = '' }) => (
  <div className="flex flex-col">
    <label className="text-[10px] uppercase tracking-wider text-zinc-400 mb-1">{label}</label>
    <input
      type="text"
      value={value || ''}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full px-2 py-1.5 bg-zinc-800 border border-zinc-700 rounded text-white text-sm focus:border-emerald-500 focus:outline-none"
    />
  </div>
);

// ==================== FORMATO DE IMPRESIÓN TALLER ====================

const FormatoImpresionTaller = React.forwardRef(({ datos, clienteNombre, numeroPedido }, ref) => {
  const config = datos.configuracion || {};
  const medidas = datos.medidasCamisa || {};
  const tecnicas = datos.opcionesTecnicas || {};
  const bordado = datos.bordado || {};
  
  const estiloInfo = ESTILOS_CAMISA.find(e => e.id === config.estilo);
  const cuelloInfo = TIPOS_CUELLO.find(c => c.id === config.cuello);
  const punoInfo = TIPOS_PUNO.find(p => p.id === config.punos);
  const cierreInfo = TIPOS_CIERRE.find(c => c.id === config.cierre);
  const pinzasInfo = TIPOS_PINZAS.find(p => p.id === config.pinzas);
  const colorBordadoInfo = COLORES_BORDADO.find(c => c.id === bordado.colorBordado);
  
  const fechaHoy = new Date();
  
  // Contenido del formato
  const formatoContent = (
    <div 
      ref={ref} 
      id="formato-taller-print"
      className="formato-taller-container"
      style={{ 
        position: 'fixed',
        left: '-9999px',
        top: '-9999px',
        width: '297mm', 
        minHeight: '210mm',
        padding: '8mm',
        boxSizing: 'border-box',
        background: 'white',
        color: 'black',
        fontFamily: 'Arial, sans-serif',
        visibility: 'hidden',
        pointerEvents: 'none',
        zIndex: -9999
      }}
    >
      
      {/* CONTENIDO DEL FORMATO */}
      <div className="border-2 border-black">
        {/* FILA SUPERIOR - ENCABEZADO */}
        <div className="grid grid-cols-12 border-b-2 border-black">
          {/* Columna Medida Cuello */}
          <div className="col-span-1 border-r border-black p-2 flex items-center justify-center">
            <div className="text-center">
              <div className="text-xs font-bold">Cuello</div>
              <div className="text-lg font-bold mt-1">{medidas.cuello || '___'}</div>
            </div>
          </div>
          
          {/* Cliente y Fechas */}
          <div className="col-span-7 border-r border-black">
            <div className="border-b border-black p-2">
              <span className="text-xs">Cliente:</span>
              <span className="ml-2 font-bold">{clienteNombre || '________________________'}</span>
            </div>
            <div className="grid grid-cols-2">
              <div className="border-r border-black p-2">
                <div className="text-xs font-medium mb-1">Recibido Fábrica</div>
                <div className="grid grid-cols-3 gap-1 text-center text-xs">
                  <div className="border border-black p-1">
                    <div className="text-[8px] text-gray-500">DÍA</div>
                    <div>{fechaHoy.getDate()}</div>
                  </div>
                  <div className="border border-black p-1">
                    <div className="text-[8px] text-gray-500">MES</div>
                    <div>{fechaHoy.getMonth() + 1}</div>
                  </div>
                  <div className="border border-black p-1">
                    <div className="text-[8px] text-gray-500">AÑO</div>
                    <div>{fechaHoy.getFullYear()}</div>
                  </div>
                </div>
              </div>
              <div className="p-2">
                <div className="text-xs font-medium mb-1">Entrega Fábrica</div>
                <div className="grid grid-cols-3 gap-1 text-center text-xs">
                  <div className="border border-black p-1">
                    <div className="text-[8px] text-gray-500">DÍA</div>
                    <div>___</div>
                  </div>
                  <div className="border border-black p-1">
                    <div className="text-[8px] text-gray-500">MES</div>
                    <div>___</div>
                  </div>
                  <div className="border border-black p-1">
                    <div className="text-[8px] text-gray-500">AÑO</div>
                    <div>___</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Distribuidor y No. */}
          <div className="col-span-4">
            <div className="border-b border-black p-2 text-center">
              <div className="text-xs text-gray-500">Distribuidor</div>
              <div className="font-bold text-lg">JPM & CO SAS</div>
            </div>
            <div className="p-2 text-center">
              <div className="text-xs text-gray-500">No.</div>
              <div className="font-bold text-xl">{numeroPedido || '______'}</div>
            </div>
          </div>
        </div>
        
        {/* CUERPO PRINCIPAL */}
        <div className="grid grid-cols-12">
          {/* COLUMNA IZQUIERDA - MEDIDAS */}
          <div className="col-span-1 border-r border-black">
            {/* Espalda */}
            <div className="border-b border-black p-2 text-center">
              <div className="text-xs font-bold">Espalda</div>
              <div className="text-lg font-bold">{medidas.espalda || '___'}</div>
            </div>
            {/* Brazo */}
            <div className="border-b border-black p-2 text-center">
              <div className="text-xs font-bold">Brazo</div>
              <div className="text-lg font-bold">{medidas.brazo || '___'}</div>
            </div>
            {/* Manga */}
            <div className="border-b border-black p-2 text-center">
              <div className="text-xs font-bold">Manga</div>
              <div className="text-lg font-bold">{medidas.manga || '___'}</div>
            </div>
            {/* Largo */}
            <div className="border-b border-black p-2 text-center">
              <div className="text-xs font-bold">Largo</div>
              <div className="text-lg font-bold">{medidas.largo || '___'}</div>
            </div>
            {/* Pecho */}
            <div className="border-b border-black p-2 text-center">
              <div className="text-xs font-bold">Pecho</div>
              <div className="text-lg font-bold">{medidas.pecho || '___'}</div>
            </div>
            {/* Cintura */}
            <div className="border-b border-black p-2 text-center">
              <div className="text-xs font-bold">Cintura</div>
              <div className="text-lg font-bold">{medidas.cintura || '___'}</div>
            </div>
            {/* Puño */}
            <div className="border-b border-black p-2 text-center">
              <div className="text-xs font-bold">Puño</div>
              <div className="text-lg font-bold">{medidas.puno || '___'}</div>
            </div>
            {/* Cadera */}
            <div className="p-2 text-center">
              <div className="text-xs font-bold">Cadera</div>
              <div className="text-lg font-bold">{medidas.cadera || '___'}</div>
            </div>
          </div>
          
          {/* COLUMNA CENTRAL - OPCIONES TÉCNICAS Y BORDADO */}
          <div className="col-span-5 border-r border-black">
            {/* Sección Bordado (Iniciales) */}
            <div className="border-b border-black p-2">
              <div className="grid grid-cols-4 gap-2 text-xs">
                <div>
                  <div className="text-gray-500 mb-1">Iniciales</div>
                  <div className="flex gap-1">
                    {(bordado.textoBordado || '').split('').map((letra, idx) => (
                      <div key={`letra-${idx}-${letra}`} className="w-6 h-6 border border-black flex items-center justify-center font-bold">
                        {letra}
                      </div>
                    ))}
                    {!bordado.textoBordado && [1,2,3,4,5].map(num => (
                      <div key={`placeholder-${num}`} className="w-6 h-6 border border-black"></div>
                    ))}
                  </div>
                </div>
                <div>
                  <div className="text-gray-500 mb-1">Parte</div>
                  <div className="font-medium">{PARTES_BORDADO.find(p => p.id === bordado.parteBordado)?.nombre || '___'}</div>
                </div>
                <div>
                  <div className="text-gray-500 mb-1">Color</div>
                  <div className="flex items-center gap-1">
                    {colorBordadoInfo && (
                      <div className="w-4 h-4 rounded-full border border-black" style={{ backgroundColor: colorBordadoInfo.hex }}></div>
                    )}
                    <span className="font-medium">{colorBordadoInfo?.nombre || '___'}</span>
                  </div>
                </div>
                <div>
                  <div className="text-gray-500 mb-1">Cantidad</div>
                  <div className="font-medium">{bordado.cantidadBordado || '1'}</div>
                </div>
              </div>
            </div>
            
            {/* Opciones Técnicas en tabla */}
            <div className="p-2">
              <table className="w-full text-xs border-collapse">
                <tbody>
                  <tr className="border-b border-gray-300">
                    <td className="py-1 font-medium text-gray-600">Referencia</td>
                    <td className="py-1 font-bold">{cuelloInfo?.id || '___'}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-1 font-medium text-gray-600">cuello</td>
                    <td className="py-1">{cuelloInfo?.nombre || '___'}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-1 font-medium text-gray-600">puño</td>
                    <td className="py-1">{punoInfo?.nombre || (estiloInfo?.mangaCorta ? 'N/A' : '___')}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-1 font-medium text-gray-600">bolsillo</td>
                    <td className="py-1">{TIPOS_BOLSILLO.find(b => b.id === tecnicas.bolsillo)?.nombre || '___'}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-1 font-medium text-gray-600">manga</td>
                    <td className="py-1">{estiloInfo?.mangaCorta ? 'Corta' : (TIPOS_MANGA.find(m => m.id === tecnicas.tipoManga)?.nombre || 'Larga')}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-1 font-medium text-gray-600">pechera</td>
                    <td className="py-1">{cierreInfo?.nombre || '___'}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-1 font-medium text-gray-600">espalda</td>
                    <td className="py-1">{pinzasInfo?.nombre || '___'}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-1 font-medium text-gray-600">dobladillo</td>
                    <td className="py-1">{TIPOS_DOBLADILLO.find(d => d.id === tecnicas.dobladillo)?.nombre || 'Recto'}</td>
                  </tr>
                  <tr>
                    <td className="py-1 font-medium text-gray-600">portañuela</td>
                    <td className="py-1">{tecnicas.portanuela || '___'}</td>
                  </tr>
                </tbody>
              </table>
              
              {/* Botones, Talla, Ojal */}
              <div className="grid grid-cols-3 gap-2 mt-3 pt-2 border-t border-gray-300">
                <div>
                  <div className="text-gray-500 text-[10px]">Botones</div>
                  <div className="font-medium">{tecnicas.botones || '___'}</div>
                </div>
                <div>
                  <div className="text-gray-500 text-[10px]">Talla</div>
                  <div className="font-medium">{tecnicas.talla || '___'}</div>
                </div>
                <div>
                  <div className="text-gray-500 text-[10px]">Ojal contraste</div>
                  <div className="font-medium">{tecnicas.ojalContraste ? 'Sí' : 'No'}</div>
                </div>
              </div>
            </div>
          </div>
          
          {/* COLUMNA DERECHA - DISEÑO Y OBSERVACIONES */}
          <div className="col-span-6">
            {/* Diseño Plan - Usa la imagen REAL del estilo configurado */}
            <div className="border-b border-black p-2">
              <div className="text-xs font-medium text-gray-500 text-center mb-2">Diseño plan</div>
              
              {/* Contenedor del diseño plan */}
              <div className="flex gap-4">
                {/* Imagen del estilo seleccionado */}
                <div 
                  className="flex-shrink-0 flex items-center justify-center bg-white"
                  style={{ width: '120px', height: '150px' }}
                >
                  {estiloInfo?.imagen ? (
                    <img 
                      src={estiloInfo.imagen}
                      alt={estiloInfo.nombre}
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '100%', 
                        objectFit: 'contain',
                        filter: 'grayscale(100%) contrast(1.2)'
                      }}
                    />
                  ) : (
                    <div className="text-gray-400 text-xs text-center">
                      Sin imagen
                    </div>
                  )}
                </div>
                
                {/* Lista de opciones aplicadas */}
                <div className="flex-1 text-xs">
                  <div className="font-bold text-gray-700 mb-2 border-b border-gray-300 pb-1">
                    Opciones aplicadas:
                  </div>
                  <table className="w-full">
                    <tbody>
                      <tr>
                        <td className="text-gray-500 py-0.5">Estilo:</td>
                        <td className="font-medium py-0.5">{estiloInfo?.nombre || '___'}</td>
                      </tr>
                      <tr>
                        <td className="text-gray-500 py-0.5">Cierre:</td>
                        <td className="font-medium py-0.5">{cierreInfo?.nombre || '___'}</td>
                      </tr>
                      <tr>
                        <td className="text-gray-500 py-0.5">Cuello:</td>
                        <td className="font-medium py-0.5">{cuelloInfo ? `Cuello ${cuelloInfo.id}` : '___'}</td>
                      </tr>
                      <tr>
                        <td className="text-gray-500 py-0.5">Puño:</td>
                        <td className="font-medium py-0.5">
                          {estiloInfo?.mangaCorta ? 'N/A (manga corta)' : (punoInfo ? `Puño ${punoInfo.id}` : '___')}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-gray-500 py-0.5">Pinzas:</td>
                        <td className="font-medium py-0.5">{pinzasInfo?.nombre || '___'}</td>
                      </tr>
                      {config.perroBordado && (
                        <tr>
                          <td className="text-gray-500 py-0.5">Perro:</td>
                          <td className="font-medium py-0.5">Sí ({colorBordadoInfo?.nombre || 'color pendiente'})</td>
                        </tr>
                      )}
                      {bordado.textoBordado && (
                        <>
                          <tr>
                            <td className="text-gray-500 py-0.5">Iniciales:</td>
                            <td className="font-medium py-0.5">{bordado.textoBordado}</td>
                          </tr>
                          <tr>
                            <td className="text-gray-500 py-0.5">Caligrafía:</td>
                            <td className="font-medium py-0.5">
                              {CALIGRAFIAS.find(c => c.id === bordado.caligrafia)?.nombre || '___'}
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            {/* Observaciones */}
            <div className="p-2">
              <div className="text-xs font-medium text-gray-500 mb-1">Observaciones:</div>
              <div className="border border-black min-h-[100px] p-2 text-sm">
                {datos.observaciones || ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  
  // Usar portal para renderizar directamente en el body
  return ReactDOM.createPortal(formatoContent, document.body);
});

FormatoImpresionTaller.displayName = 'FormatoImpresionTaller';

// ==================== COMPONENTE PRINCIPAL ====================

const ConfiguradorCamisaCompleto = ({ 
  datos = {}, 
  onChange, 
  clienteNombre = '', 
  numeroPedido = '',
  errores = [] 
}) => {
  const printRef = useRef(null);
  
  // Estado interno completo
  const [config, setConfig] = useState(() => ({
    // Medidas de camisa
    medidasCamisa: {
      cuello: datos.medidasCamisa?.cuello || '',
      espalda: datos.medidasCamisa?.espalda || '',
      brazo: datos.medidasCamisa?.brazo || '',
      manga: datos.medidasCamisa?.manga || '',
      largo: datos.medidasCamisa?.largo || '',
      pecho: datos.medidasCamisa?.pecho || '',
      cintura: datos.medidasCamisa?.cintura || '',
      puno: datos.medidasCamisa?.puno || '',
      cadera: datos.medidasCamisa?.cadera || ''
    },
    // Configuración visual
    configuracion: {
      estilo: datos.configuracion?.estilo || '',
      cierre: datos.configuracion?.cierre || '',
      cuello: datos.configuracion?.cuello || '',
      punos: datos.configuracion?.punos || '',
      pinzas: datos.configuracion?.pinzas || '',
      perroBordado: datos.configuracion?.perroBordado || false
    },
    // Bordado
    bordado: {
      textoBordado: datos.bordado?.textoBordado || '',
      colorBordado: datos.bordado?.colorBordado || '',
      caligrafia: datos.bordado?.caligrafia || '',
      parteBordado: datos.bordado?.parteBordado || 'puno_izquierdo',
      cantidadBordado: datos.bordado?.cantidadBordado || '1'
    },
    // Opciones técnicas
    opcionesTecnicas: {
      bolsillo: datos.opcionesTecnicas?.bolsillo || 'sin_bolsillo',
      tipoManga: datos.opcionesTecnicas?.tipoManga || 'larga',
      dobladillo: datos.opcionesTecnicas?.dobladillo || 'recto',
      portanuela: datos.opcionesTecnicas?.portanuela || '',
      botones: datos.opcionesTecnicas?.botones || '',
      talla: datos.opcionesTecnicas?.talla || '',
      ojalContraste: datos.opcionesTecnicas?.ojalContraste || false
    },
    // Campo interno obligatorio (NO se imprime)
    referenciaTela: datos.referenciaTela || '',
    // Observaciones
    observaciones: datos.observaciones || ''
  }));

  // Secciones expandidas
  const [seccionesExpandidas, setSeccionesExpandidas] = useState({
    medidas: true,
    configuracion: true,
    bordado: false,
    tecnicas: false
  });

  const toggleSeccion = (seccion) => {
    setSeccionesExpandidas(prev => ({ ...prev, [seccion]: !prev[seccion] }));
  };

  // Derivados
  const estiloInfo = useMemo(() => ESTILOS_CAMISA.find(e => e.id === config.configuracion.estilo), [config.configuracion.estilo]);
  const esMangaCorta = estiloInfo?.mangaCorta;
  const necesitaColorBordado = config.configuracion.perroBordado || (config.bordado.textoBordado && config.bordado.textoBordado.length > 0);

  // Función para actualizar config y notificar al padre
  const actualizarConfig = useCallback((path, valor) => {
    setConfig(prev => {
      const newConfig = { ...prev };
      const keys = path.split('.');
      let obj = newConfig;
      
      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
      }
      obj[keys[keys.length - 1]] = valor;
      
      // Lógica especial: si cambia estilo a manga corta, limpiar puños
      if (path === 'configuracion.estilo') {
        const nuevoEstilo = ESTILOS_CAMISA.find(e => e.id === valor);
        if (nuevoEstilo?.mangaCorta) {
          newConfig.configuracion.punos = 'no_aplica';
          newConfig.opcionesTecnicas.tipoManga = 'corta';
        } else if (newConfig.configuracion.punos === 'no_aplica') {
          newConfig.configuracion.punos = '';
          newConfig.opcionesTecnicas.tipoManga = 'larga';
        }
      }
      
      // Notificar al padre
      if (onChange) {
        setTimeout(() => onChange(newConfig), 0);
      }
      
      return newConfig;
    });
  }, [onChange]);

  // Función de impresión
  const handlePrint = () => {
    // Validar que haya referencia de tela antes de imprimir
    if (!config.referenciaTela) {
      alert('Debe ingresar la Referencia de Tela antes de imprimir el formato de taller.');
      return;
    }
    
    // Obtener el elemento del formato
    const formatoElement = document.getElementById('formato-taller-print');
    if (!formatoElement) {
      alert('Error: No se encontró el formato de impresión.');
      return;
    }
    
    // Guardar el estilo original
    const originalStyle = formatoElement.getAttribute('style');
    
    // Mover el elemento a posición visible para impresión
    formatoElement.style.position = 'fixed';
    formatoElement.style.left = '0';
    formatoElement.style.top = '0';
    formatoElement.style.width = '100%';
    formatoElement.style.zIndex = '999999';
    
    // Imprimir
    setTimeout(() => {
      window.print();
      
      // Restaurar el estilo original después de imprimir
      setTimeout(() => {
        formatoElement.setAttribute('style', originalStyle);
      }, 100);
    }, 50);
  };

  // Validación de campos obligatorios
  const camposIncompletos = useMemo(() => {
    const faltantes = [];
    if (!config.configuracion.estilo) faltantes.push('Estilo');
    if (!config.configuracion.cierre) faltantes.push('Cierre');
    if (!config.configuracion.cuello) faltantes.push('Cuello');
    if (!esMangaCorta && !config.configuracion.punos) faltantes.push('Puños');
    if (!config.configuracion.pinzas) faltantes.push('Pinzas');
    if (necesitaColorBordado && !config.bordado.colorBordado) faltantes.push('Color del bordado');
    if (config.bordado.textoBordado && !config.bordado.caligrafia) faltantes.push('Caligrafía');
    if (!config.referenciaTela) faltantes.push('Referencia de Tela');
    return faltantes;
  }, [config, esMangaCorta, necesitaColorBordado]);

  return (
    <div className="bg-zinc-900 rounded-2xl overflow-hidden" style={{ maxWidth: '100%', overflowX: 'hidden' }}>
      {/* Header con botón de impresión */}
      <div className="bg-gradient-to-r from-emerald-900/50 to-zinc-800 p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Shirt className="w-6 h-6 text-emerald-500" />
          <div>
            <h2 className="text-lg font-bold text-white">Configuración de Prenda - Camisa</h2>
            <p className="text-xs text-zinc-400">Medidas, opciones técnicas, bordado y formato de taller</p>
          </div>
        </div>
        
        <button
          type="button"
          onClick={handlePrint}
          disabled={camposIncompletos.length > 0}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all ${
            camposIncompletos.length > 0
              ? 'bg-zinc-700 text-zinc-500 cursor-not-allowed'
              : 'bg-emerald-600 text-white hover:bg-emerald-700 shadow-lg shadow-emerald-500/20'
          }`}
          title={camposIncompletos.length > 0 ? `Faltan: ${camposIncompletos.join(', ')}` : 'Imprimir formato de taller'}
        >
          <Printer className="w-4 h-4" />
          Imprimir Formato Taller
        </button>
      </div>

      {/* Errores */}
      {errores.length > 0 && (
        <div className="mx-4 mt-4 p-3 bg-red-500/10 border border-red-500/30 rounded-lg">
          <div className="flex items-start gap-2">
            <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
            <div>
              {errores.map((error) => (
                <p key={`error-${error.substring(0, 30)}`} className="text-sm text-red-400">{error}</p>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Campos incompletos (aviso) */}
      {camposIncompletos.length > 0 && (
        <div className="mx-4 mt-4 p-3 bg-amber-500/10 border border-amber-500/30 rounded-lg">
          <div className="flex items-start gap-2">
            <Info className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm text-amber-400">Campos pendientes: {camposIncompletos.join(', ')}</p>
            </div>
          </div>
        </div>
      )}

      <div className="p-4">
        {/* ==================== SECCIÓN 1: REFERENCIA DE TELA (OBLIGATORIO - NO SE IMPRIME) ==================== */}
        <div className="mb-4 p-4 bg-rose-900/20 border border-rose-500/30 rounded-xl no-print">
          <div className="flex items-center gap-2 mb-3">
            <Scissors className="w-5 h-5 text-rose-400" />
            <span className="font-semibold text-white">Referencia de Tela</span>
            <span className="text-rose-400 text-xs">(Obligatorio - USO INTERNO)</span>
          </div>
          <input
            type="text"
            value={config.referenciaTela}
            onChange={(e) => actualizarConfig('referenciaTela', e.target.value)}
            placeholder="Ej: PAÑOS JP-204 Azul Marino"
            className="w-full px-4 py-3 bg-zinc-800 border border-rose-500/30 rounded-lg text-white placeholder-zinc-500 focus:border-rose-400 focus:outline-none"
          />
          <p className="text-xs text-rose-300/60 mt-2">
            * Este campo es obligatorio para guardar pero NO aparece en el formato impreso de taller.
          </p>
        </div>

        {/* ==================== SECCIÓN 2: MEDIDAS DE CAMISA ==================== */}
        <div className="mb-4">
          <button
            type="button"
            onClick={() => toggleSeccion('medidas')}
            className="w-full flex items-center justify-between p-3 bg-zinc-800/80 rounded-lg hover:bg-zinc-800 transition-colors"
          >
            <div className="flex items-center gap-2">
              <Hash className="w-5 h-5 text-blue-400" />
              <span className="font-semibold text-white">Medidas de Camisa</span>
            </div>
            {seccionesExpandidas.medidas ? <ChevronUp className="w-5 h-5 text-zinc-400" /> : <ChevronDown className="w-5 h-5 text-zinc-400" />}
          </button>
          
          {seccionesExpandidas.medidas && (
            <div className="mt-3 p-4 bg-zinc-800/30 rounded-lg">
              <div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-9 gap-3">
                <MedidaInput label="Cuello" value={config.medidasCamisa.cuello} onChange={(e) => actualizarConfig('medidasCamisa.cuello', e.target.value)} />
                <MedidaInput label="Espalda" value={config.medidasCamisa.espalda} onChange={(e) => actualizarConfig('medidasCamisa.espalda', e.target.value)} />
                <MedidaInput label="Brazo" value={config.medidasCamisa.brazo} onChange={(e) => actualizarConfig('medidasCamisa.brazo', e.target.value)} />
                <MedidaInput label="Manga" value={config.medidasCamisa.manga} onChange={(e) => actualizarConfig('medidasCamisa.manga', e.target.value)} />
                <MedidaInput label="Largo" value={config.medidasCamisa.largo} onChange={(e) => actualizarConfig('medidasCamisa.largo', e.target.value)} />
                <MedidaInput label="Pecho" value={config.medidasCamisa.pecho} onChange={(e) => actualizarConfig('medidasCamisa.pecho', e.target.value)} />
                <MedidaInput label="Cintura" value={config.medidasCamisa.cintura} onChange={(e) => actualizarConfig('medidasCamisa.cintura', e.target.value)} />
                <MedidaInput label="Puño" value={config.medidasCamisa.puno} onChange={(e) => actualizarConfig('medidasCamisa.puno', e.target.value)} />
                <MedidaInput label="Cadera" value={config.medidasCamisa.cadera} onChange={(e) => actualizarConfig('medidasCamisa.cadera', e.target.value)} />
              </div>
            </div>
          )}
        </div>

        {/* ==================== SECCIÓN 3: CONFIGURACIÓN VISUAL ==================== */}
        <div className="mb-4">
          <button
            type="button"
            onClick={() => toggleSeccion('configuracion')}
            className="w-full flex items-center justify-between p-3 bg-zinc-800/80 rounded-lg hover:bg-zinc-800 transition-colors"
          >
            <div className="flex items-center gap-2">
              <Shirt className="w-5 h-5 text-emerald-400" />
              <span className="font-semibold text-white">Estilo, Cuello, Puños y Pinzas</span>
            </div>
            {seccionesExpandidas.configuracion ? <ChevronUp className="w-5 h-5 text-zinc-400" /> : <ChevronDown className="w-5 h-5 text-zinc-400" />}
          </button>
          
          {seccionesExpandidas.configuracion && (
            <div className="mt-3 p-4 bg-zinc-800/30 rounded-lg">
              <SeccionSelector
                titulo="Estilo de Camisa *"
                opciones={ESTILOS_CAMISA}
                valorSeleccionado={config.configuracion.estilo}
                onSelect={(v) => actualizarConfig('configuracion.estilo', v)}
                columnas={4}
                mostrarManga={true}
              />
              
              <SeccionSelector
                titulo="Cierre / Pechera *"
                opciones={TIPOS_CIERRE}
                valorSeleccionado={config.configuracion.cierre}
                onSelect={(v) => actualizarConfig('configuracion.cierre', v)}
                columnas={3}
              />
              
              <SeccionSelector
                titulo="Cuello *"
                opciones={TIPOS_CUELLO}
                valorSeleccionado={config.configuracion.cuello}
                onSelect={(v) => actualizarConfig('configuracion.cuello', v)}
                columnas={4}
                compact
              />
              
              {!esMangaCorta ? (
                <SeccionSelector
                  titulo="Puños *"
                  opciones={TIPOS_PUNO}
                  valorSeleccionado={config.configuracion.punos}
                  onSelect={(v) => actualizarConfig('configuracion.punos', v)}
                  columnas={5}
                  compact
                />
              ) : (
                <div className="mb-3 p-2.5 bg-zinc-800/30 rounded-lg">
                  <span className="font-medium text-zinc-500 text-sm">Puños</span>
                  <span className="ml-2 text-xs text-amber-500">No aplica por manga corta</span>
                </div>
              )}
              
              <SeccionSelector
                titulo="Pinzas (Espalda) *"
                opciones={TIPOS_PINZAS}
                valorSeleccionado={config.configuracion.pinzas}
                onSelect={(v) => actualizarConfig('configuracion.pinzas', v)}
                columnas={2}
              />
            </div>
          )}
        </div>

        {/* ==================== SECCIÓN 4: BORDADO ==================== */}
        <div className="mb-4">
          <button
            type="button"
            onClick={() => toggleSeccion('bordado')}
            className="w-full flex items-center justify-between p-3 bg-zinc-800/80 rounded-lg hover:bg-zinc-800 transition-colors"
          >
            <div className="flex items-center gap-2">
              <Palette className="w-5 h-5 text-amber-400" />
              <span className="font-semibold text-white">Bordado y Personalización</span>
            </div>
            {seccionesExpandidas.bordado ? <ChevronUp className="w-5 h-5 text-zinc-400" /> : <ChevronDown className="w-5 h-5 text-zinc-400" />}
          </button>
          
          {seccionesExpandidas.bordado && (
            <div className="mt-3 p-4 bg-zinc-800/30 rounded-lg">
              {/* Perro bordado */}
              <div className="mb-4">
                <label className="text-sm font-medium text-zinc-300 mb-2 block">¿Lleva perro bordado?</label>
                <div className="flex gap-3">
                  <button
                    type="button"
                    onClick={() => actualizarConfig('configuracion.perroBordado', true)}
                    className={`flex-1 py-2 px-4 rounded-lg font-medium transition-colors ${
                      config.configuracion.perroBordado
                        ? 'bg-emerald-500 text-white'
                        : 'bg-zinc-700 text-zinc-300 hover:bg-zinc-600'
                    }`}
                  >
                    Sí
                  </button>
                  <button
                    type="button"
                    onClick={() => actualizarConfig('configuracion.perroBordado', false)}
                    className={`flex-1 py-2 px-4 rounded-lg font-medium transition-colors ${
                      !config.configuracion.perroBordado
                        ? 'bg-zinc-600 text-white'
                        : 'bg-zinc-700 text-zinc-300 hover:bg-zinc-600'
                    }`}
                  >
                    No
                  </button>
                </div>
              </div>
              
              {/* Letras bordadas */}
              <div className="mb-4">
                <label className="text-sm font-medium text-zinc-300 mb-2 flex items-center gap-2">
                  <Type className="w-4 h-4" />
                  Iniciales bordadas
                  <span className="text-xs text-zinc-500">(máx. 5 caracteres)</span>
                </label>
                <input
                  type="text"
                  value={config.bordado.textoBordado}
                  onChange={(e) => {
                    const valor = e.target.value.slice(0, 5).toUpperCase();
                    actualizarConfig('bordado.textoBordado', valor);
                  }}
                  maxLength={5}
                  placeholder="Ej: JPM"
                  className="w-full px-4 py-3 bg-zinc-800 border border-zinc-700 rounded-lg text-white placeholder-zinc-500 focus:border-emerald-500 focus:outline-none"
                />
              </div>
              
              {/* Parte del bordado */}
              {(config.configuracion.perroBordado || config.bordado.textoBordado) && (
                <div className="mb-4">
                  <label className="text-sm font-medium text-zinc-300 mb-2 block">Ubicación del bordado</label>
                  <select
                    value={config.bordado.parteBordado}
                    onChange={(e) => actualizarConfig('bordado.parteBordado', e.target.value)}
                    className="w-full px-4 py-3 bg-zinc-800 border border-zinc-700 rounded-lg text-white focus:border-emerald-500 focus:outline-none"
                  >
                    {PARTES_BORDADO.map(parte => (
                      <option key={parte.id} value={parte.id}>{parte.nombre}</option>
                    ))}
                  </select>
                </div>
              )}
              
              {/* Cantidad */}
              {(config.configuracion.perroBordado || config.bordado.textoBordado) && (
                <div className="mb-4">
                  <label className="text-sm font-medium text-zinc-300 mb-2 block">Cantidad de bordados</label>
                  <input
                    type="number"
                    min="1"
                    max="5"
                    value={config.bordado.cantidadBordado}
                    onChange={(e) => actualizarConfig('bordado.cantidadBordado', e.target.value)}
                    className="w-24 px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white focus:border-emerald-500 focus:outline-none"
                  />
                </div>
              )}
              
              {/* Color del bordado */}
              <SelectorColores
                titulo={`Color del bordado ${necesitaColorBordado ? '*' : ''}`}
                colores={COLORES_BORDADO}
                valorSeleccionado={config.bordado.colorBordado}
                onSelect={(v) => actualizarConfig('bordado.colorBordado', v)}
                deshabilitado={!necesitaColorBordado}
              />
              
              {/* Caligrafía */}
              {config.bordado.textoBordado && (
                <div className="mb-4">
                  <label className="text-sm font-medium text-zinc-300 mb-2 block">Caligrafía *</label>
                  <div className="grid grid-cols-3 gap-2">
                    {CALIGRAFIAS.map((cal) => (
                      <button
                        key={cal.id}
                        type="button"
                        onClick={() => actualizarConfig('bordado.caligrafia', cal.id)}
                        className={`p-3 rounded-lg border-2 transition-colors ${
                          config.bordado.caligrafia === cal.id
                            ? 'border-emerald-500 bg-emerald-500/10'
                            : 'border-zinc-700 bg-zinc-800/50 hover:border-zinc-600'
                        }`}
                      >
                        <div className="text-lg text-center text-white mb-1" style={{ fontFamily: cal.fontFamily }}>
                          ABC
                        </div>
                        <div className="text-xs text-center text-zinc-400">{cal.nombre}</div>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* ==================== SECCIÓN 5: OPCIONES TÉCNICAS ==================== */}
        <div className="mb-4">
          <button
            type="button"
            onClick={() => toggleSeccion('tecnicas')}
            className="w-full flex items-center justify-between p-3 bg-zinc-800/80 rounded-lg hover:bg-zinc-800 transition-colors"
          >
            <div className="flex items-center gap-2">
              <Scissors className="w-5 h-5 text-purple-400" />
              <span className="font-semibold text-white">Opciones Técnicas (Autollenado)</span>
            </div>
            {seccionesExpandidas.tecnicas ? <ChevronUp className="w-5 h-5 text-zinc-400" /> : <ChevronDown className="w-5 h-5 text-zinc-400" />}
          </button>
          
          {seccionesExpandidas.tecnicas && (
            <div className="mt-3 p-4 bg-zinc-800/30 rounded-lg">
              <p className="text-xs text-zinc-400 mb-4">
                Algunos campos se auto-llenan según las selecciones anteriores. Puede ajustar manualmente si es necesario.
              </p>
              
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {/* Bolsillo */}
                <div>
                  <label className="text-xs text-zinc-400 mb-1 block">Bolsillo</label>
                  <select
                    value={config.opcionesTecnicas.bolsillo}
                    onChange={(e) => actualizarConfig('opcionesTecnicas.bolsillo', e.target.value)}
                    className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded text-white text-sm focus:border-emerald-500 focus:outline-none"
                  >
                    {TIPOS_BOLSILLO.map(b => (
                      <option key={b.id} value={b.id}>{b.nombre}</option>
                    ))}
                  </select>
                </div>
                
                {/* Tipo Manga */}
                <div>
                  <label className="text-xs text-zinc-400 mb-1 block">Tipo de Manga</label>
                  <select
                    value={config.opcionesTecnicas.tipoManga}
                    onChange={(e) => actualizarConfig('opcionesTecnicas.tipoManga', e.target.value)}
                    disabled={esMangaCorta}
                    className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded text-white text-sm focus:border-emerald-500 focus:outline-none disabled:opacity-50"
                  >
                    {TIPOS_MANGA.map(m => (
                      <option key={m.id} value={m.id}>{m.nombre}</option>
                    ))}
                  </select>
                </div>
                
                {/* Dobladillo */}
                <div>
                  <label className="text-xs text-zinc-400 mb-1 block">Dobladillo</label>
                  <select
                    value={config.opcionesTecnicas.dobladillo}
                    onChange={(e) => actualizarConfig('opcionesTecnicas.dobladillo', e.target.value)}
                    className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded text-white text-sm focus:border-emerald-500 focus:outline-none"
                  >
                    {TIPOS_DOBLADILLO.map(d => (
                      <option key={d.id} value={d.id}>{d.nombre}</option>
                    ))}
                  </select>
                </div>
                
                {/* Portañuela */}
                <div>
                  <label className="text-xs text-zinc-400 mb-1 block">Portañuela</label>
                  <input
                    type="text"
                    value={config.opcionesTecnicas.portanuela}
                    onChange={(e) => actualizarConfig('opcionesTecnicas.portanuela', e.target.value)}
                    placeholder="Especificar..."
                    className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded text-white text-sm focus:border-emerald-500 focus:outline-none"
                  />
                </div>
                
                {/* Botones */}
                <div>
                  <label className="text-xs text-zinc-400 mb-1 block">Botones</label>
                  <input
                    type="text"
                    value={config.opcionesTecnicas.botones}
                    onChange={(e) => actualizarConfig('opcionesTecnicas.botones', e.target.value)}
                    placeholder="Ej: Blancos, Nacar..."
                    className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded text-white text-sm focus:border-emerald-500 focus:outline-none"
                  />
                </div>
                
                {/* Talla */}
                <div>
                  <label className="text-xs text-zinc-400 mb-1 block">Talla</label>
                  <input
                    type="text"
                    value={config.opcionesTecnicas.talla}
                    onChange={(e) => actualizarConfig('opcionesTecnicas.talla', e.target.value)}
                    placeholder="Ej: M, L, XL..."
                    className="w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded text-white text-sm focus:border-emerald-500 focus:outline-none"
                  />
                </div>
                
                {/* Ojal Contraste */}
                <div className="col-span-2 md:col-span-3">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={config.opcionesTecnicas.ojalContraste}
                      onChange={(e) => actualizarConfig('opcionesTecnicas.ojalContraste', e.target.checked)}
                      className="w-4 h-4 rounded border-zinc-600 bg-zinc-800 text-emerald-500 focus:ring-emerald-500"
                    />
                    <span className="text-sm text-zinc-300">Ojal contraste</span>
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* ==================== SECCIÓN 6: VISTA PREVIA DEL BOCETO TÉCNICO ==================== */}
        <div className="mb-4">
          <div className="text-sm font-semibold text-white mb-3 flex items-center gap-2">
            <Shirt className="w-5 h-5 text-cyan-400" />
            Vista Previa del Boceto Técnico
          </div>
          <VistaPreviaCamisa config={config} />
        </div>

        {/* ==================== SECCIÓN 7: RESUMEN DE CAMISA ==================== */}
        <div className="mb-4">
          <ResumenCamisa config={config} />
        </div>

        {/* ==================== OBSERVACIONES ==================== */}
        <div className="mb-4">
          <label className="text-sm font-medium text-zinc-300 mb-2 block">Observaciones</label>
          <textarea
            value={config.observaciones}
            onChange={(e) => actualizarConfig('observaciones', e.target.value)}
            rows={3}
            placeholder="Notas adicionales para producción..."
            className="w-full px-4 py-3 bg-zinc-800 border border-zinc-700 rounded-lg text-white placeholder-zinc-500 focus:border-emerald-500 focus:outline-none resize-none"
          />
        </div>
      </div>

      {/* FORMATO DE IMPRESIÓN (OCULTO EN PANTALLA, VISIBLE AL IMPRIMIR) */}
      <FormatoImpresionTaller
        ref={printRef}
        datos={config}
        clienteNombre={clienteNombre}
        numeroPedido={numeroPedido}
      />
    </div>
  );
};

// ==================== FUNCIONES EXPORTADAS ====================

export const validarConfiguracionCamisaCompleta = (datos) => {
  const errores = [];
  const config = datos.configuracion || {};
  const bordado = datos.bordado || {};
  
  if (!config.estilo) errores.push('Selecciona un estilo de camisa.');
  if (!config.cierre) errores.push('Selecciona un tipo de cierre.');
  if (!config.cuello) errores.push('Selecciona un cuello.');
  
  const estiloInfo = ESTILOS_CAMISA.find(e => e.id === config.estilo);
  if (!estiloInfo?.mangaCorta && !config.punos) errores.push('Selecciona un puño.');
  if (!config.pinzas) errores.push('Selecciona el tipo de pinzas.');
  
  if ((config.perroBordado || bordado.textoBordado) && !bordado.colorBordado) {
    errores.push('Selecciona el color del bordado.');
  }
  if (bordado.textoBordado && !bordado.caligrafia) {
    errores.push('Selecciona la caligrafía del bordado.');
  }
  if (!datos.referenciaTela) {
    errores.push('Ingresa la referencia de tela.');
  }
  
  return errores;
};

export const getConfiguracionCamisaCompletaInicial = () => ({
  medidasCamisa: {
    cuello: '', espalda: '', brazo: '', manga: '', largo: '',
    pecho: '', cintura: '', puno: '', cadera: ''
  },
  configuracion: {
    estilo: '', cierre: '', cuello: '', punos: '', pinzas: '', perroBordado: false
  },
  bordado: {
    textoBordado: '', colorBordado: '', caligrafia: '',
    parteBordado: 'puno_izquierdo', cantidadBordado: '1'
  },
  opcionesTecnicas: {
    bolsillo: 'sin_bolsillo', tipoManga: 'larga', dobladillo: 'recto',
    portanuela: '', botones: '', talla: '', ojalContraste: false
  },
  referenciaTela: '',
  observaciones: ''
});

export default ConfiguradorCamisaCompleto;
